import React, { useEffect } from "react";

// Components
import TextInput from "components/input/TextInput";
import SelectInput from "components/input/SelectInput";
import MultipleSelectInput from "components/input/MultipleSelectInput";

// Data
import {
  options,
  previous_qualifications,
  received_gov_fund_options,
} from "utils/constants/data";

function PreviousQualifications({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
}) {
  useEffect(() => {
    if (!values.is_succeed_prev_qualification) {
      setFieldValue(`prev_qualifications`, []);
    }
    if (!values.is_received_gov_fund) {
      setFieldValue(`first_time_this_qualification`, false);
      setFieldValue(`advise_qualification`, "");
    }
  }, [values.is_succeed_prev_qualification, values.is_received_gov_fund]);

  return (
    <div className="bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold">
        Previous Qualifications Achieved
      </p>
      <hr className="h-1 border-none text-[#333] bg-[#333]" />
      <p className="uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold">
        16. Have you successfully completed any of the qualifications listed in
        question 17?
      </p>
      <div className="flex flex-col space-y-2">
        {options.map((option, i) => {
          return (
            <div className="flex flex-row items-center space-x-3">
              <div>
                <input
                  checked={
                    values.is_succeed_prev_qualification === option.value
                  }
                  id={`success-prev-qual-radio-btn-${i}`}
                  name={`success-prev-qual-${i}`}
                  type="radio"
                  onChange={() =>
                    setFieldValue(`is_succeed_prev_qualification`, option.value)
                  }
                  value={values.is_succeed_prev_qualification}
                  className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                />
              </div>
              <p className="text-base xl:text-lg" key={i}>
                {option.title}
              </p>
            </div>
          );
        })}
      </div>
      {values.is_succeed_prev_qualification === false && (
        <p className="text-sm xl:text-base font-semibold">
          If "No" – Go To Question 18.
        </p>
      )}
      {values.is_succeed_prev_qualification && (
        <div className="space-y-4 sm:space-y-6">
          <p className="uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold">
            17. If "yes", tick any applicable boxes.
          </p>
          <MultipleSelectInput
            name="prev_qualifications"
            classNameInput="text-base md:text-lg lg:text-xl"
            label=""
            options={previous_qualifications}
            placeholder="Select achieved previous qualifications..."
            setFieldValue={setFieldValue}
            onBlur={handleBlur}
            error={
              errors?.prev_qualifications &&
              touched?.prev_qualifications &&
              errors.prev_qualifications
            }
            value={values.prev_qualifications}
          />
          <p className="text-sm xl:text-base">
            Note: For SA-Based Candidates, you may be entitled to SA
            Government-Based Funding. Please advise if you have received such
            funding in the past, and for what qualification:
          </p>
          <div className="flex flex-col space-y-2">
            {received_gov_fund_options.map((option, i) => {
              return (
                <div className="flex flex-row items-center space-x-3">
                  <div>
                    <input
                      checked={values.is_received_gov_fund === option.value}
                      id={`government-funding-radio-btn-${i}`}
                      name={`government-funding-${i}`}
                      type="radio"
                      onChange={() =>
                        setFieldValue(`is_received_gov_fund`, option.value)
                      }
                      value={values.is_received_gov_fund}
                      className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                    />
                  </div>
                  <p className="text-base xl:text-lg" key={i}>
                    {option.title}
                  </p>
                </div>
              );
            })}
          </div>
          {errors?.is_received_gov_fund &&
            touched?.is_received_gov_fund &&
            errors.is_received_gov_fund && (
              <p className="text-xs sm:text-sm xl:text-base text-red-500">
                {errors.is_received_gov_fund}
              </p>
            )}
        </div>
      )}
      {values.is_received_gov_fund && (
        <div className="space-y-4 sm:space-y-6">
          <p className="text-sm xl:text-base font-semibold">If "Yes", then:</p>
          <div className="flex flex-row items-center space-x-3">
            <div>
              <input
                checked={values.first_time_this_qualification === true}
                id={`first-time-qual-checkbox-btn`}
                name={`first-time-qual`}
                type="checkbox"
                onChange={() =>
                  setFieldValue(
                    `first_time_this_qualification`,
                    !values.first_time_this_qualification
                  )
                }
                value={values.first_time_this_qualification}
                className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
              />
            </div>
            <p className="text-base xl:text-lg">
              First Time For This Qualification
            </p>
          </div>
          <SelectInput
            name="advise_qualification"
            classNameInput="text-base xl:text-lg"
            label="Advise Qualification:"
            options={[
              {
                id: "BSB50820 Diploma of Project Management",
                text: "BSB50820 Diploma of Project Management",
              },
            ]}
            placeholder="Select..."
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              errors?.advise_qualification &&
              touched?.advise_qualification &&
              errors.advise_qualification
            }
            value={values.advise_qualification}
          />
        </div>
      )}
    </div>
  );
}

export default PreviousQualifications;
